import { render, staticRenderFns } from "./UpdateCapacity.vue?vue&type=template&id=4f53d632"
import script from "./UpdateCapacity.vue?vue&type=script&lang=js"
export * from "./UpdateCapacity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports